import React from "react";
import "../css/ourPartners.css";

const OurPartners = ({ data }) => {
  return (
    <section
      className="py-md-5 lazy-bg skeleton loaded our-clients"
      data-bg="url(/images/partner.png)"
      style={{
        backgroundImage: "url('/images/partner.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <h2 className="text-center default-box-title">ĐỐI TÁC CỦA CHÚNG TÔI</h2>
        <p className="description">
          Chất lượng uy tín, hợp tác và gắn bó với các đối tác trong quá trình
          hoạt động kinh doanh.
        </p>
        <div className="row items">
          {data.map((item, index) => (
            <div key={index} className="col-lg-2 col-md-4 col-6 item  ">
              <div className="text-center client-logo lazy-container position-relative">
                <div
                  className="skeleton aspect-ratio-client-logo"
                  style={{ display: "none" }}
                ></div>
                <img
                  data-src={item.imageUrl}
                  alt={item.title}
                  loading="lazy"
                  src={item.imageUrl}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPartners;
